import { gql } from 'apollo-angular';
import EmbeddableReport from '../../../interfaces/embeddable-report';

export type GetReportResponse = {
  embeddableReports: EmbeddableReport[];
};
export type GetReportVariables = {};
const GET_EMBEDDABLE_REPORT = gql<GetReportResponse, GetReportVariables>`
  query getEmbeddableReports {
    embeddableReports {
      id
      name
      base_url
      full_url
      filter_map
      app_id
      report_id
      ctid
      committee_dashboard
    }
  }
`;

export { GET_EMBEDDABLE_REPORT };
